import {handleActions} from 'redux-actions';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

export default handleActions(
    {
        [Actions.fetchAllSuccess.type]: (state, {payload}) => payload.behaviors,
    },
    new BehaviorsCollection([]),
);
